<template>
  <div>
    <div class="tips-main">
      <div class="tips-box">
        <div class="small-bell-box">
          <img class="small-bell" src="@/assets/image/hb/small-bell.png" />
        </div>
        <img class="bg" src="@/assets/image/hb/bg.png" />

        <div class="tips-box-title1">尊敬的会员用户</div>
        <div class="tips-box-title2">2025年7月14日0时起微信兑换全面升级</div>

        <div class="step-box">
          <div class="step-box-item">
            <img class="step1" src="@/assets/image/hb/step1.png" />
            <div class="step-box-item-text">
              <img class="hb01" src="@/assets/image/hb/01.png" />
              <div class="text">关注「爱答卷」公众号</div>
            </div>
          </div>

          <img class="arrow-right" src="@/assets/image/hb/arrow-right.png" />
          <div class="step-box-item step-box-item2">
            <div class="step2-box">
              <img class="step2" src="@/assets/image/hb/step2.png" />
              <img class="step2-1" src="@/assets/image/hb/step2-1.png" />
            </div>
            <div class="step-box-item-text">
              <img class="hb02" src="@/assets/image/hb/02.png" />
              <div class="text">绑定账号</div>
            </div>
          </div>
        </div>

        <div class="step-box">
          <div class="step-box-item step-box-item3">
            <img class="step3" src="@/assets/image/hb/step3.png" />
            <div class="step-box-item-text">
              <img class="hb01" src="@/assets/image/hb/03.png" />
              <div class="text">点击「兑换」</div>
            </div>
          </div>

          <img class="arrow-right" src="@/assets/image/hb/arrow-right.png" />
          <div class="step-box-item step-box-item4">
            <img class="step4" src="@/assets/image/hb/step4.png" />
            <div class="step-box-item-text">
              <img class="hb01" src="@/assets/image/hb/04.png" />
              <div class="text">微信扫码领取</div>
            </div>
          </div>
        </div>

        <div class="notes">
          注: <span>信用值≤100</span>的会员, 绑定账户之后需要在<span
            >「我的-兑换记录」-- 点击「去领取」</span
          >，等待<span>人工审核</span>订单后，可微信扫描二维码领取金额！
        </div>

        <div class="notes">
          <img class="exclamation" src="@/assets/image/hb/exclamation.png" />
          在绑定之前请确保您的微信不是小号、不常用的号、微信账号必须要实名认证，否则将无法收到微信红包！
        </div>

        <div class="countdown-box" v-if="timeNumber">
          请仔细阅读（倒计时{{ timeNumber }}s）
        </div>
        <div class="countdown-box2" v-else @click="next">我知道了</div>
      </div>
    </div>

    <div class="tips-main-pc">
      <div class="tips-box">
        <div class="tips-box-top">
          <img class="bg-img" src="@/assets/image/pcTips/bg-top.png" />

          <div class="tips-box-text">
            <img class="notice" src="@/assets/image/pcTips/notice.png" />
            关于「兑换流程升级」通知
          </div>
        </div>
        <div class="tips-box-content">
          <div class="tips-box-content-title1">尊敬的会员用户：</div>
          <div class="tips-box-content-title2">
            2025年7月14日0时起爱答卷微信兑换全面升级
          </div>
          <div class="tips-box-content-title3">
            <img
              class="exclamation"
              src="@/assets/image/pcTips/exclamation.png"
            />
            在绑定之前请确保您的微信不是小号、不常用的号、微信账号必须要实名认证，否则将无法收到微信红包
          </div>

          <div class="tips-box-content-title4">详细兑换步骤如下：</div>

          <div class="step-box">
            <div class="step-box-item">
              <img class="step1" src="@/assets/image/pcTips/step1.png" />
              <div class="step-box-item-text">关注「爱答卷」公众号</div>
            </div>
            <img
              class="arrow-right"
              src="@/assets/image/pcTips/arrow-right.png"
            />

            <div class="step-box-item">
              <div class="step2-box">
                <img class="step2" src="@/assets/image/pcTips/step2.png" />
                <img class="step2-1" src="@/assets/image/pcTips/step2-1.png" />
              </div>
              <div class="step-box-item-text">绑定账号</div>
            </div>

            <img
              class="arrow-right"
              src="@/assets/image/pcTips/arrow-right.png"
            />
            <div class="step-box-item">
              <img class="step3" src="@/assets/image/pcTips/step3.png" />
              <div class="step-box-item-text">点击「兑换」选择金额</div>
            </div>

            <img
              class="arrow-right"
              src="@/assets/image/pcTips/arrow-right.png"
            />
            <div class="step-box-item">
              <img class="step4" src="@/assets/image/pcTips/step4.png" />
              <div class="step-box-item-text step-box-item-blod">
                微信扫码领取
              </div>
            </div>
          </div>

          <div class="step-box2">
            <div class="step-box-item">
              <div class="step5-box">
                <img class="step5" src="@/assets/image/pcTips/step5.png" />
                <img class="step5-1" src="@/assets/image/pcTips/step5-1.png" />
              </div>
              <div class="step-box-item-text">微信扫码后「点击查看」</div>
            </div>
            <img
              class="arrow-right arrow-right1"
              src="@/assets/image/pcTips/arrow-right.png"
            />
            <div class="step-box-item">
              <div class="step6-box">
                <img class="step6" src="@/assets/image/pcTips/step6.png" />
                <img class="step6-1" src="@/assets/image/pcTips/step6-1.png" />
              </div>
              <div class="step-box-item-text">点击领取</div>
            </div>
            <img
              class="arrow-right arrow-right2"
              src="@/assets/image/pcTips/arrow-right.png"
            />

            <div class="step-box-item">
              <div class="step7-box">
                <img class="step7" src="@/assets/image/pcTips/step7.png" />
                <img class="step7-1" src="@/assets/image/pcTips/step7-1.png" />
              </div>
              <div class="step-box-item-text">领取成功</div>
            </div>
            <img
              class="arrow-right arrow-right3"
              src="@/assets/image/pcTips/arrow-right.png"
            />
            <div class="step-box-item">
              <img class="step8" src="@/assets/image/pcTips/step8.png" />
              <div class="step-box-item-text">可在微信支付中查看</div>
            </div>
          </div>

          <div class="notes">
            注: <span>信用值≤100</span>的会员,绑定账户之后需要在<span
              >「我的-兑换记录」-- 点击「去领取」</span
            >，等待<span>人工审核订</span>单后，可扫描二维码领取金额！
          </div>

          <div class="countdown-box" v-if="timeNumber">
            请仔细阅读 ({{ timeNumber }}s)
          </div>
          <div class="countdown-box2" v-else @click="next">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { setCashoutAgreement, getAccount } from "@/api/user";
export default {
  data() {
    return {
      time: null,
      timeNumber: 1,
      isFlag: false,
      page: 1,
      name: "",
      idCard: "",
      phoneNumber: "",
      userInfo: {},
    };
  },
  methods: {
    ...mapActions(["setAccount"]),
    close() {
      clearInterval(this.time);
      this.time = null;
      this.timeNumber = 30;
      this.page = 1;
      this.$emit("close");
    },
    next() {
      this.countdown();
    },
    async countdown() {
      if (this.isFlag) {
        return;
      }

      this.isFlag = true;

      setCashoutAgreement({
        accepted: true,
      }).then(async (res) => {
        if (res.code === 200) {
          await getAccount().then((res) => {
            if (res.code === 200) {
              this.userInfo = res.data;
              this.$store.commit("changeUserInfo", this.userInfo);
              localStorage.setItem("userInfo", JSON.stringify(res.data));
              this.close();
              this.$emit("changeAccepted");
              this.isFlag = false;
            } else {
              this.isFlag = false;
            }
          });
        } else {
          this.isFlag = false;
        }
      });
    },
  },
  created() {
    this.time = setInterval(() => {
      this.timeNumber--;
      if (this.timeNumber === 0) {
        clearInterval(this.time);
        this.time = null;
      }
    }, 1000);
  },
};
</script>
<style lang="scss" scoped>
.tips-main {
  display: none;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 2000;
  overflow: auto;

  .tips-box {
    margin-top: 50px;
    max-width: 302px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    padding: 4px;
    box-sizing: border-box;
    padding-bottom: 20px;
    .small-bell-box {
      width: 60px;
      height: 60px;
      background: linear-gradient(322deg, #ff6a00 0%, #ffc300 100%);
      box-shadow: inset 0px 0px 10px 0px #ffffff;
      border: 4px solid #ffffff;
      border-radius: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: -30px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      .small-bell {
        width: 44px;
        height: 44px;
      }
    }
    .bg {
      width: 100%;
      height: 153px;
      position: absolute;
      top: 0;
      left: 0;
    }

    .tips-box-title1 {
      text-align: center;
      color: #232323;
      font-size: 16px;
      font-weight: bolder;
      margin-top: 37px;
    }
    .tips-box-title2 {
      color: #232323;
      text-align: center;
      font-size: 14px;
      margin-top: 8px;
    }
    .step-box {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      position: relative;
      .step-box-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        .step1 {
          width: 62px;
          height: 60px;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
          border-radius: 8px 8px 8px 8px;
          margin-bottom: 12px;
        }
        .step2-box {
          position: relative;
          width: 113px;
          height: 52px;
          margin-bottom: 16px;
          .step2 {
            width: 113px;
            height: 52px;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #ffffff;
            margin-right: 15px;
          }
          .step2-1 {
            position: absolute;
            right: -3px;
            top: -3px;
            width: 48px;
            height: 20px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
            border-radius: 6px 6px 6px 6px;
          }
        }

        .step3 {
          width: 48px;
          height: 102px;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #ffffff;
          margin-bottom: 16px;
        }
        .step4 {
          width: 77px;
          height: 103px;
          background: linear-gradient(
            180deg,
            #fff9e5 0%,
            rgba(255, 255, 255, 0) 100%
          );
          margin-bottom: 16px;
        }
        .step-box-item-text {
          position: relative;
          .hb01 {
            position: absolute;
            width: 12px;
            height: 12px;
            left: 10px;
            top: -4px;
            z-index: 1;
          }
          .hb02 {
            position: absolute;
            width: 12px;
            height: 12px;
            left: 10px;
            top: -4px;
            z-index: 1;
          }
          .text {
            position: relative;
            color: #232323;
            font-size: 12px;
            z-index: 2;
            margin-left: 18px;
          }
        }
      }
      .step-box-item2 {
        margin-right: 15px;
      }
      .step-box-item3 {
        margin-left: 22px;
      }
      .step-box-item4 {
        margin-right: 26px;
      }
      .arrow-right {
        position: absolute;
        width: 12px;
        height: 10px;
        top: 31px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .notes {
      width: 100%;
      box-sizing: border-box;
      padding: 0 10px 0 12px;
      color: #232323;
      font-size: 14px;
      margin-top: 15px;
      span {
        color: #ff9713;
      }
      .exclamation {
        width: 14px;
        height: 14px;
      }
    }

    .countdown-box {
      width: 192px;
      height: 37px;
      background: #e1e1e1;
      border-radius: 4px 4px 4px 4px;
      line-height: 37px;
      color: #fff;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 25px;
      flex-shrink: 0;
      text-align: center;
    }

    .countdown-box2 {
      width: 87px;
      height: 37px;
      background: linear-gradient(87deg, #ff4e3e 0%, #ffb330 0%, #ff6200 100%);
      border-radius: 4px 4px 4px 4px;
      line-height: 37px;
      color: #fff;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 19px;
      flex-shrink: 0;
      text-align: center;
      cursor: pointer;
      margin-top: 25px;
      font-size: 14px;
    }
  }
}

.tips-main-pc {
  display: block;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 100000;

  .tips-box {
    width: 724px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    top: 30px;
    background-color: #ffffff;
    // height: 465px;
    border-radius: 8px;
    .tips-box-top {
      width: 100%;
      height: 80px;
      position: relative;
      background: linear-gradient(116deg, #ffa100 0%, #ffbb00 100%);
      border-radius: 8px 8px 0px 0px;
      .bg-img {
        width: 100%;
        height: 100%;
      }
      .tips-box-text {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        color: #ffffff;
        font-size: 20px;
        font-weight: bolder;
        .notice {
          width: 23px;
          height: 23px;
          margin: 0 15px 0 30px;
        }
      }
    }
    .tips-box-content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 0 0 8px 8px;
      position: relative;
      padding: 25px 30px 30px 30px;
      box-sizing: border-box;
      .tips-box-content-title1 {
        color: #3d3d3d;
        font-size: 16px;
        font-weight: bolder;
      }
      .tips-box-content-title2 {
        color: #333333;
        font-size: 14px;
        margin-top: 14px;
      }
      .tips-box-content-title3 {
        display: flex;
        align-items: center;
        color: #ff4e3e;
        margin-top: 7px;
        .exclamation {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }

      .tips-box-content-title4 {
        color: #3d3d3d;
        font-size: 14px;
        font-weight: bolder;
        margin-top: 10px;
      }
      .step-box {
        display: flex;
        align-items: center;
        margin-top: 10px;
        height: 130px;
        justify-content: space-between;
        .step-box-item {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: center;
          height: 130px;
          .step1 {
            width: 90px;
            height: 88px;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 17px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
          }
          .step2-box {
            width: 181px;
            height: 83px;
            position: relative;
            margin-bottom: 16px;
            .step2 {
              width: 181px;
              height: 83px;
              box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
              border-radius: 8px 8px 8px 8px;
              border: 1px solid #ffffff;
            }
            .step2-1 {
              position: absolute;
              width: 77px;
              height: 32px;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
              border-radius: 6px 6px 6px 6px;
              top: -10px;
              right: -5px;
            }
          }
          .step3 {
            width: 171px;
            height: 96px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 15px;
          }
          .step4 {
            width: 77px;
            height: 103px;
            margin-bottom: 16px;
            background: linear-gradient(
              180deg,
              #fff9e5 0%,
              rgba(255, 255, 255, 0) 100%
            );
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          }
          .step-box-item-text {
            color: #333333;
            font-size: 12px;
          }
          .step-box-item-blod {
            font-weight: bolder;
          }
        }
        .arrow-right {
          width: 14px;
          height: 14px;
          margin-bottom: 0 12px 45px 12px;
        }
      }
      .step-box2 {
        display: flex;
        align-items: center;
        margin-top: 26px;
        height: 180px;
        justify-content: space-between;
        .step-box-item {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: center;
          .step5-box {
            position: relative;
            margin-bottom: 14px;
            width: 77px;
            height: 137px;
            .step5 {
              width: 77px;
              height: 137px;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              border-radius: 4px 4px 4px 4px;
            }
            .step5-1 {
              position: absolute;
              width: 113px;
              height: 20px;
              box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
              border-radius: 326px 326px 326px 326px;
              top: 55px;
              left: -18px;
            }
          }

          .step6-box {
            position: relative;
            margin-bottom: 12px;
            width: 77px;
            height: 137px;
            .step6 {
              width: 77px;
              height: 137px;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              border-radius: 4px 4px 4px 4px;
            }
            .step6-1 {
              position: absolute;
              width: 122px;
              height: 20px;
              box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
              border-radius: 163px 163px 163px 163px;
              top: 51px;
              left: -23px;
            }
          }

          .step7-box {
            position: relative;
            margin-bottom: 14px;
            width: 77px;
            height: 137px;
            .step7 {
              width: 77px;
              height: 137px;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              border-radius: 4px 4px 4px 4px;
            }
            .step7-1 {
              position: absolute;
              width: 90px;
              height: 53px;
              box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
              border-radius: 4px 4px 4px 4px;
              top: 38px;
              left: -5px;
            }
          }

          .step8 {
            width: 77px;
            height: 137px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px 4px 4px 4px;
            margin-bottom: 14px;
          }

          .step-box-item-text {
            color: #333333;
            font-size: 12px;
          }
          .step-box-item-blod {
            font-weight: bolder;
          }
        }
        .arrow-right {
          width: 14px;
          height: 14px;
          margin-bottom: 0 12px 45px 12px;
        }
        .arrow-right1 {
          margin-left: 18px;
          margin-right: 33px;
        }
        .arrow-right2 {
          margin-left: 52px;
          margin-right: 41px;
        }
        .arrow-right3 {
          margin-left: 51px;
          margin-right: 32px;
        }
      }
      .notes {
        color: #333333;
        font-size: 14px;
        font-weight: bolder;
        margin-top: 13px;
        span {
          color: #ff4e3e;
          font-size: 16px;
        }
      }
      .countdown-box {
        width: 192px;
        height: 37px;
        background: #e1e1e1;
        border-radius: 4px 4px 4px 4px;
        line-height: 37px;
        color: #fff;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 19px;
        flex-shrink: 0;
        text-align: center;
        cursor: no-drop;
      }

      .countdown-box2 {
        width: 86px;
        height: 36px;
        background: linear-gradient(
          87deg,
          #ff4e3e 0%,
          #ffb330 0%,
          #ff6200 100%
        );
        border-radius: 4px 4px 4px 4px;
        line-height: 37px;
        color: #fff;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 19px;
        flex-shrink: 0;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

@media only screen and (max-width: 750px) {
  .tips-main {
    display: block;
  }
  .tips-main-pc {
    display: none;
  }
}
</style>


